import styled, { css } from 'styled-components'

import { PairInformationCurrency } from '@root/entities/pair/ui'
import { PairInformationFavorite } from '@root/features/favorite-pairs/ui/desktop/pair-information-favorite'

import { PairLink, PairIcon } from '../common'

import { PairSearchItemInfo } from './pair-search-item-info'

import type { PairModel } from '../../atoms/reatom-pair'
import type { PairInformationCurrencyProps } from '@root/entities/pair/ui'
import type { ClassNameProps } from '@root/shared/react'

// TODO: Move to features

type Props = {
  pair: PairModel
  onClick?: (pair: PairModel) => void
} & ClassNameProps &
  Pick<PairInformationCurrencyProps, 'onLinkClick'>

export const PairSearchItem: React.FC<Props> = ({
  pair,
  onClick,
  className,
  onLinkClick,
}) => {
  return (
    <PairSearchItemRoot className={className}>
      <PairBackgroundLink
        pair={pair}
        onClick={onClick ? () => onClick(pair) : undefined}
      />
      <PairInformationFavorite
        pair={pair}
        size={24}
        css={css`
          margin-inline-end: 3px;
        `}
      />
      <PairIcon withPairPopover pair={pair} size={42} providerSize={15} />
      <PairInformationCurrency
        pair={pair}
        withSocials
        withAge
        withProvider
        withAddress
        withAudit
        onLinkClick={onLinkClick}
        withPriceChange
      />
      <PairSearchItemInfo pair={pair} onLinkClick={onLinkClick} />
    </PairSearchItemRoot>
  )
}

export const PairSearchItemRoot = styled.div`
  border: 1px solid var(--backgroundA-3);
  background: var(--background-2);
  cursor: pointer;
  position: relative;

  display: grid;
  grid-template-columns: auto auto 3fr 1.2fr;
  gap: 10px;

  height: 64px;
  border-radius: 12px;
  padding-inline: 12px;

  justify-content: center;
  align-items: center;

  &:hover {
    background: var(--appearanceA-3);
  }
`

const PairBackgroundLink = styled(PairLink<PairModel>)`
  position: absolute;
  inset: 0;
`
